<template>
  <v-dialog
    width="700"
    v-model="showDialog"
  >
    <v-card>
      <div class="clearfix">
        <v-btn
          class="pull-right btn-transparent"
          icon
          plain
          @click="clearMessage"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div class="pa-5">
        <p class="d-flex justify-space-around pb-5" v-html="value.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
      </div>

      <div class="d-flex justify-space-around pb-3 px-5 flex-wrap">
        <v-btn
            color="primary"
            outlined
            @click="clearMessage"
            class="mb-2"
        >
          {{ $t('dss.continueWithoutAlgorithm') }}
        </v-btn>
        <v-btn
            color="primary"
            outlined
            @click="backToDashboard"
            class="mb-2"
        >
          {{ $t('dss.backtoDashboard') }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Component MissingDSSDataPopup.vue
 *
 * @module MissingDSSDataPopup
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/MissingDSSDataPopup.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MissingDSSDataPopup',
  props: {
    value: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  methods: {
    backToDashboard: function(){
      this.clearMessage()
      this.$router.push({ name: 'PatientOverview' })
    },
    clearMessage(){
      this.$emit('input', '');
    }
  },
  computed: {
    showDialog() {
      return !!this.value;
    },
  },
};
</script>
